import {
    TextField,
    InputLabel,
    Grid,
    Typography,
    Box,
    Tooltip
} from "@mui/material";
import { setshowCompanyAliasError } from "../reducers/global-reducer";
import { useSelector, useDispatch } from "react-redux";
import { useTranslate } from "react-redux-multilingual";
import { useMediaQuery } from "@mui/material";
import { ReactComponent as PreviewIcon } from "../../src/assets/Images/PreviewIcon.svg"
import { customLogs } from "./util/util";

const Confdata = window['runConfig'];

const uniqueUserNameStyling = {
    fontFamily: 'Quicksand-Regular',
    width: '16rem',
    margin: '0px 0px 0px 10px'
}

const uniqueUserNameStyling2 = {
    fontFamily: 'Quicksand-Regular',
    width: '16rem',
    position: 'relative',
    top: '5px',
}

const SetUpLink = ({ formik, service }) => {
    const dispatch = useDispatch();
    const matches = useMediaQuery('(min-width:500px)');
    const store = useSelector(state => state);
    const { companyAliasExist, showCompanyAliasError } = store.globalreducer;
    const t = useTranslate();


    customLogs(formik, "formik")


    const handleCompanyAlias = (e) => {
        dispatch(setshowCompanyAliasError(false));
        formik.handleChange(e)

    }

    const style={
        subhead:{ textAlign: 'center', margin: '3rem 0 -20px 0' },
        subhead2:{ textAlign: 'center', margin: '1rem 0 -40px 0' }
    }

    return (
        <form noValidate>
            {
                service.includes("JODOLINKINDIVIDUAL") ?
                    <div>
                        <Typography variant="subHeading" sx={style.subhead}>
                            {t('setupurl1')}
                        </Typography>
                        <Typography variant="subHeading" sx={style.subhead2}>
                            {t('setupurl2')}
                        </Typography>
                    </div>
                    :
                    (service.includes("JODOMEETING") || service.includes("WORDPRESS")) ?
                        null :
                        <div>
                            <Typography variant="subHeading" sx={style.subhead}>
                                {t('setupurl1')}
                            </Typography>
                            <Typography variant="subHeading" sx={style.subhead2}>
                                {t('setupurl2')}
                            </Typography>
                        </div>

            }


            {
                (service.includes("WORDPRESS")) ?
                    <Grid >
                        <Grid container className="setuplink-grid-wordPress">
                            <Grid>
                                <InputLabel className="domainname-lable">Domain Name</InputLabel>
                            </Grid>
                            <TextField
                                sx={{ width: '16rem', m: '0px 0px 20px 10px' }}
                                // className='inputRounded'
                                label={t('domainName')}
                                id="domainName"
                                name="domainName"
                                // required
                                value={formik.values?.domainName}
                                onChange={formik.handleChange}
                                error={(formik.touched.domainName && Boolean(formik.errors.domainName))} //
                                helperText={(formik.touched.domainName && formik.errors.domainName)}
                                inputProps={{ maxLength: 250 }}
                            />


                        </Grid>
                    </Grid> :
                    (service.includes("JODOMEETING")) ?
                        <Grid container className="setupLink-grid">
                            <h3> {t('completeSubscriptionProcess')} </h3>
                        </Grid>
                        :
                        service.includes("JODOLINKINDIVIDUAL") ?
                            <Grid container className="setuplink-grid-jodoindividual">
                                <Tooltip title={`${Confdata.apiUrl}/${service.includes('JODOLINKINDIVIDUAL') ? 'JL' : ''}/`}>
                                    <Box bgcolor="grey.200" p={2} sx={{ height: '19px' }}>
                                        <Typography variant="subHeading"

                                        >
                                            {`${Confdata.apiUrl}/${service.includes('JODOLINKINDIVIDUAL') ? 'JL' : ''}/`}
                                        </Typography>
                                    </Box>
                                </Tooltip>
                                <TextField
                                    sx={{ width: '16rem', m: '30px 0px 0px 10px' }}
                                    // className='inputRounded'
                                    required
                                    id="orgAlias"
                                    name="orgAlias"
                                    // label="uniqueCompanyName"
                                    label={t('uniqueURL')}
                                    value={formik.values.orgAlias}
                                    onChange={handleCompanyAlias}
                                    error={(formik.touched.orgAlias && Boolean(formik.errors.orgAlias)) || showCompanyAliasError}
                                    helperText={(formik.touched.orgAlias && formik.errors.orgAlias) || (showCompanyAliasError && t('uniqueCompanyID'))}
                                    inputProps={{ maxLength: 250 }}
                                    InputLabelProps={{
                                        sx: {
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        },
                                        '&.MuiInputLabel-shrink': {
                                            fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                          },
                                          transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                        
                                    }}
                                />




                            </Grid>
                            :
                            <Grid container className="setupLink-grid" >
                                <Tooltip title={`${Confdata.apiUrl}/${service.includes('JODOLINK') ? 'JL' : 'JLT'}/`}>
                                    {/* <Box bgcolor="grey.200" p={2} sx={{ height: '19px', marginTop: "5px" }}> */}
                                    <Typography
                                        variant="subHeading"

                                    >
                                        {`${Confdata.apiUrl}/${service.includes('JODOLINK') ? 'JL' : 'JLT'}/`}
                                    </Typography>
                                    {/* </Box> */}
                                </Tooltip>
                                <TextField
                                    sx={{ width: '16rem', m: '10px 0px 5px 20px', }}
                                    // className='inputRounded'
                                    required title={t('tooltip_name')}
                                    id="orgAlias"
                                    name="orgAlias"
                                    label={t('uniqueCompanyName')}
                                    value={formik.values.orgAlias}
                                    onChange={handleCompanyAlias}
                                    error={(formik.touched.orgAlias && Boolean(formik.errors.orgAlias)) || showCompanyAliasError}
                                    inputProps={{ maxLength: 250 }}
                                    helperText={(formik.touched.orgAlias && formik.errors.orgAlias) || (showCompanyAliasError && t('uniqueCompanyID'))}
                                    InputLabelProps={{
                                        sx: {
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        },
                                        '&.MuiInputLabel-shrink': {
                                            fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                          },
                                          transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                        
                                    }}
                                />




                                {
                                    service.includes('JODOLINK') &&
                                    <>
                                        <Typography variant="subHeading">
                                            /
                                        </Typography>
                                        <TextField
                                            sx={matches ? uniqueUserNameStyling : uniqueUserNameStyling2}
                                            style={{ marginTop: "5px" }}
                                            // className='inputRounded'
                                            id="userAlias"
                                            name="userAlias"
                                            label={t('uniqueUserName')}
                                            // placeholder={t('uniqueUserName')}
                                            required title={t('tooltip_name')}
                                            value={formik.values.userAlias}
                                            onChange={formik.handleChange}
                                            error={formik.touched.userAlias && Boolean(formik.errors.userAlias)}
                                            helperText={formik.touched.userAlias && formik.errors.userAlias}
                                            inputProps={{ maxLength: 250 }}
                                            InputLabelProps={{
                                                sx: {
                                                    '& .MuiFormLabel-asterisk': {
                                                        color: 'red',
                                                    },
                                                },
                                                '&.MuiInputLabel-shrink': {
                                                    fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                                  },
                                                  transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                                
                                            }}
                                        />
                                    </>
                                }
                                {
                                    service.includes('JODOLINK') &&  store.globalreducer.language !=="en" &&
                                    <Tooltip title={'Please enter a unique user and company name. It should not include special characters or symbols'}>
                                        <PreviewIcon  style={{height:"24px",width:"24px", marginLeft:"10px"}}/>
                                    </Tooltip>

                                }
                            </Grid>
            }

            {service.includes("JODOLINKINDIVIDUAL") ? '' :
                (service.includes("JODOMEETING") || service.includes("WORDPRESS")) ?
                    null
                    :
                    <div className="billing-detail-page">
                        <Typography variant='normal' sx={{ width: `${matches ? '46%' : '100%'}` }}> {t('setupurlmesgthree')}</Typography>
                    </div>

            }
        </form>
    )
}

export default SetUpLink;